
import { useState } from "react";
import { object, string } from "yup";
import * as yup from "yup";
import {
  getFields,
  enderecoValidation,
  informacoesGeraisValidation,
  contatoValidation,
  validaCNPJ,
  validaCPF,
} from "~services/utils/defaultValidations";

const useProspectValidate = (tipoPessoa = null) => {
  const [valuess, setValue] = useState({ name: "", value: "" });

  const validationSchema = object({
    ...getFields(enderecoValidation(), ['cep','numero','complemento','uf','rua','bairro','cidadeId']),
    ...getFields(informacoesGeraisValidation(), ['nomeFantasia', 'tipo', 'dataNascimento', 'trilhaId', 'grupoSegmentoId', 'segmentoId']),
    documento: string()
    .test("cnpjCpf", "CPF ou CNPJ incompleto!", function(value) {
        if (tipoPessoa === 1 && value?.length > 0 && value?.length !== 14) {
          return this.createError({ message: "Número de CPF inválido!" });
        } else if (tipoPessoa === 2 && value?.length > 0 && value?.length !== 18) {
          return this.createError({ message: "Número de CNPJ inválido!" });
        }

        if(value){
          if (value.length === 14) {
            if (!validaCPF(value)) {
              return this.createError({ message: "O número de CPF é inválido" });
            }

            return string()
              .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, {
                message: "CPF inválido",
                excludeEmptyString: true,
              })
              .isValidSync(value);
          } else if (value.length === 18) {
            if (!validaCNPJ(value)) {
              return this.createError({ message: "O número de CNPJ é inválido" });
            }

            return string()
              .matches(/^([A-Za-z0-9]{2})\.([A-Za-z0-9]{3})\.([A-Za-z0-9]{3})\/([A-Za-z0-9]{4})-\d{2}$/, {
                message: "CNPJ inválido",
                excludeEmptyString: true,
              })
              .isValidSync(value);
          }
          return false;
        }
        return true;
    }).nullable(),
    contatos: yup.array().of(yup.object({
      ...getFields(contatoValidation(), ['nome', 'sobrenome', 'cargoId', 'email', 'telefone'])
    })),
    // ...getFields(informacoesAdicionaisValidation(), ['faseObra', 'sistemaConstrutivo', 'numeroPavimentos', 'quantidadeTorres', 'volumePotencial', 'negociacaoDate'])
  });

  const [initialValues, setinitialValues] = useState({
    id: 0,
    idVendMais: "",
    codigoSAP: "",
    usuarioId: 0,
    documento: "",
    cep: "",
    numero: "",
    complemento: "",
    uf: "",
    rua: "",
    bairro: "",
    cidade: "",
    cidadeId: null,
    razaoSocial: "",
    nomeFantasia: "",
    contatos: [
      {
        id: 0,
        nome: "",
        sobrenome: "",
        cargoId: null,
        email: "",
        telefone: "",
        celular: "",
      },
    ],
    trilhaId: null,
    classificacaoFiscal: "",
    grupoSegmentoId: null,
    segmentoId: null,
    grupoCentralizadorId: null,
    grupoCentralizadorConstrutoraId: null,
    filialId: null,
    produtoId: null,
    faseObra: "",
    numeroPavimentos: "",
    quantidadeTorres: "",
    negociacaoDate: "",
    sistemaConstrutivo: "",
    tipo: null,
    dataNascimento: "",
    nomeObra: "",
  });

  const cpfCnpj = (newValue) => {
    const numbersOnly = newValue.replace(/[^0-9]/g, "");
    if (numbersOnly.length <= 11) {
      // CPF
      return [
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
      ];
    } else {
      // CNPJ
      return [
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        ".",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        ".",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        "/",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        "-",
        /\d/,
        /\d/,
      ];
      }
  };

  return {
    validationSchema,
    initialValues,
    setinitialValues,
    cpfCnpj,
    setValue,
    valuess
  };
};

export default useProspectValidate;
